import * as ACTIONS from '../../constants/chart-constants';

export const storeChart = ({ backtestId, chartName, data }) => {
  return { type: ACTIONS.STORE_CHART, payload: { chartName, data, backtestId } };
};
